import type { FeatureCollection } from 'geojson';

// Uploaded-crash legend systemId; the SafeSystem crashes context (`ECrashes.UploadedCrashes`) must match it.
export const UPLOADED_CRASHES_LAYER_ID = 'Uploaded crash data';

export const customCrashesStore = $state({
	data: undefined as FeatureCollection | undefined,
	showError: false
});
